import { render, staticRenderFns } from "./QuestionPills.vue?vue&type=template&id=74f6f4e2"
import script from "./QuestionPills.vue?vue&type=script&lang=js"
export * from "./QuestionPills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports